import globals from '@descope-ui/theme-globals';
import { PasswordStrengthClass } from './component/PasswordStrengthClass';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';
import { refs } from '@descope-ui/theme-input-wrapper';

const globalRefs = getThemeRefs(globals);
const compVars = PasswordStrengthClass.cssVarList;

const passwordStrength = {
  [compVars.hostDirection]: globalRefs.direction,
  [compVars.barHeight]: '4px',
  [compVars.barTransition]: 'background-color 0.3s',
  [compVars.barBorderRadius]: globalRefs.radius.sm,
  [compVars.hostMinWidth]: refs.minWidth,
  [compVars.barSpacing]: globalRefs.spacing.sm,
  [compVars.emptyBarColor]: globalRefs.colors.surface.light,
  [compVars.fontFamily]: refs.fontFamily,
  [compVars.fontSize]: refs.labelFontSize,
  [compVars.fontWeight]: refs.labelFontWeight,
  [compVars.spacing]: globalRefs.spacing.sm,
  _fullWidth: {
    [compVars.hostWidth]: '100%',
  },
  score : {
    0: {
      [compVars.filledBarColor]: globalRefs.colors.error.light,
      [compVars.textColor]: globalRefs.colors.error.light,
    },
    1: {
      [compVars.filledBarColor]: globalRefs.colors.error.main,
      [compVars.textColor]: globalRefs.colors.error.main,
    },
    2: {
      [compVars.filledBarColor]: globalRefs.colors.error.dark,
      [compVars.textColor]: globalRefs.colors.error.dark,
    },
    3: {
      [compVars.filledBarColor]: globalRefs.colors.success.dark,
      [compVars.textColor]: globalRefs.colors.success.dark,
    },
    4: {
      [compVars.filledBarColor]: globalRefs.colors.success.main,
      [compVars.textColor]: globalRefs.colors.success.main,
    },
  }
};

export default passwordStrength;

export const vars = {
  ...compVars,
};
